module.exports = __webpack_public_path__ + "static/media/trav.d420797b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trav.jpg
// module id = 294
// module chunks = 0